import React from 'react';
import { SvgProps } from './icon.types';

function LogoCAIcon({ ...props }: SvgProps) {
  return (
    <svg viewBox="0 0 53 36" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="#FFF" fillRule="evenodd">
        <path d="M51.75 4.63l-9.2 5.05c-.73.36-1.51.26-2.03-.18-.8-.91-1.18-2.2-1.5-3.26 0 0 1.15-.3 2.06-.74C42.68 4.66 51.75 0 51.75 0v4.63zM30.74 8.62l-3.61 7.65c-.4.85-.84 2.2-1.92 2.84-2.2 1.54-7.6 2.34-7.6 2.34l-.38.05S24.1 8.51 27.41 2.45h7.32l11.77 26.2h-7.13c-1.26 0-1.18-1.05-2.51-4.43-.28-.77-6.12-15.6-6.12-15.6z" />
        <path d="M22 3.58c.42 1.22.77 2.48.98 3.75C16.11 7.47 10.36 11 6 16.16c-1.2 1.58-2.62 3.44-1.6 5.54 1.45 2.9 7.25 2.33 10.98 1.82a46.51 46.51 0 009.94-2.87L28 19.6l1.68-.81 3.34-1.72.91-.45 5.85-3.15 11.97-6.62v5.84l-9.59 5.78-6.2 3.44s-8.93 4.31-13.68 5.71c-.72.22-1 .31-1.81.5-4.57.9-9.94 1.6-14.2-.43a11.4 11.4 0 01-5.21-5.46 11.5 11.5 0 01-.81-2.84c0-.35-.07-.86-.07-1.16 0-5.07 3.83-8.9 7.46-11.74a25.5 25.5 0 012.57-1.72c.57-.3 1.52-.7 2.4-1.12 1.7-.74 3.77-1.46 5.8-1.62 1.48-.06 3.04.07 3.6 1.55M0 35.97h48.02V31.8H0z" />
      </g>
    </svg>
  );
}

export { LogoCAIcon };
